import React from "react";
import styles from "./LogoLink.module.scss";
import { Logo } from "../Logo/Logo";

type Props = {};

export const LogoLink: React.FC<Props> = () => {
  return (
    <a href="https://regie.ai" className={styles.link}>
      <Logo />
    </a>
  );
};
